import cart from './cartReducer';
import header from './headerReducer';
import footer from './footerReducer';

export default {
    cart,
    header,
    footer,
};
